<template>
  <section id="product-modes" class="product-modes">
    <div :class="['product-modes__header', 'content-padder']">
      <div class="product-modes__header-headline">
        <MultiImage
          class="product-modes__header-headline-image"
          name="img_modes_header"
        />
        <h1>
          <i18n path="product_modes_headline">
            <Copyright />
          </i18n>
        </h1>
      </div>
      <p class="product-modes__header-subheadline">
        <i18n path="product_modes_subheadline">
          <Copyright />
        </i18n>
      </p>
    </div>
    <div class="product-modes__videoandlist">
      <div class="product-modes__videoandlist__bckgrnd-container">
        <BackgroundImage
          name="img_surgeon"
          class="product-modes__videoandlist__bckgrnd-container__img"
        />
      </div>
      <div class="product-modes__videoandlist__overlay" />
      <div
        :class="[
          'product-modes__videoandlist__overlaycontent',
          'content-padder',
        ]"
      >
        <Video
          class="product-modes__videoandlist__overlaycontent__video"
          :vimeoId="modesVideoId"
          :isFullScreen="false"
        />
        <ListWithArrows
          class="product-modes__videoandlist__overlaycontent__list"
          :entriesLeft="listEntriesLeft"
          :entriesRight="listEntriesRight"
          color="white"
          flavor="white"
        />
      </div>
    </div>
    <h1 class="product-modes__header2">
      {{ $i18n.t("product_modes_headline2") }}
    </h1>
    <BackgroundImage
      name="img_surgeon"
      :class="['product-modes__descriptions', 'content-padder']"
    >
      <div class="product-modes__descriptions-item">
        <MultiImage
          class="product-modes__descriptions-item-image"
          name="img_modes_forced"
        />
        <h4 class="product-modes__descriptions-item-headline">
          {{ $i18n.t("applications_one_headline") }}
        </h4>
        <p class="product-modes__descriptions-item-text">
          {{ $i18n.t("applications_one_text") }}
        </p>
      </div>
      <div class="product-modes__descriptions-item">
        <MultiImage
          class="product-modes__descriptions-item-image"
          name="img_modes_pulsed"
        />
        <h4 class="product-modes__descriptions-item-headline">
          {{ $i18n.t("applications_two_headline") }}
        </h4>
        <p class="product-modes__descriptions-item-text">
          {{ $i18n.t("applications_two_text") }}
        </p>
      </div>
    </BackgroundImage>
  </section>
</template>
<script>
import MultiImage from "@/components/MultiImage";
import BackgroundImage from "@/components/BackgroundImage";
import Copyright from "@/components/Symbols/Copyright";
import ListWithArrows from "@/components/ListWithArrows";
import Video from "@/components/Video";

export default {
  components: {
    Video,
    Copyright,
    MultiImage,
    BackgroundImage,
    ListWithArrows,
  },
  data: function() {
    return {
      listEntriesLeft: ["product_li1", "product_li2"],
      listEntriesRight: ["product_li3", "product_li4"],
    };
  },
  computed: {
    modesVideoId() {
      return this.$store.getters.video_clinicalApplication3;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss";
.product-modes {
  &__header {
    color: $text_dark;
    background-color: $background-medium-green;
    text-align: center;
    @include padding-v(30px);
    &-headline {
      @include flex-h(center, center);
      h1 {
        @include ts-section-headline();
      }
      &-image {
        margin-right: 30px;
        height: 120px;
        @include breakpoint(xs) {
          height: 60px;
        }
        @include breakpoint(s) {
          height: 80x;
        }
      }
    }
    &-subheadline {
      @include ts-section-subheadline();
      margin-top: 10px;
    }
  }
  &__header2 {
    color: $text_dark;
    background-color: #78cdd1;
    text-align: center;
    @include padding-v(30px);
    @include ts-section-headline();
  }
  &__videoandlist {
    position: relative;
    height: 1200px;
    @include breakpoint(xs) {
      height: 700px;
    }
    @include breakpoint(s) {
      height: 700px;
    }

    &__bckgrnd-container,
    &__bckgrnd-container__img,
    &__overlay,
    &__overlaycontent {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1200px;
      @include breakpoint(xs) {
        height: 700px;
      }
      @include breakpoint(s) {
        height: 700px;
      }
    }

    &__overlaycontent {
      &__list {
        margin-bottom: 60px;
        padding: 0 70px;

        @include breakpoint(xs) {
          padding: 0 5vw;
          margin-bottom: 30px;
        }
        @include breakpoint(s) {
          margin-bottom: 30px;
        }
      }
      &__video {
        height: 45vw;
        margin: auto;
        max-height: 750px;
        max-width: 80vw;
        margin-top: 60px;
        margin-bottom: 60px;

        @include breakpoint(s) {
          height: 400px;
          margin-top: 30px;
          margin-bottom: 60px;
        }
        @include breakpoint(xs) {
          height: 56.25vw;
          margin-top: 0;
          margin-bottom: 30px;
        }
      }
    }

    &__bckgrnd-container {
      overflow: hidden;
      &__img {
        filter: blur(8px);
      }
    }
    &__overlay {
      background-color: $background-medium-green;
      mix-blend-mode: multiply;
      @include ie_or_edge() {
        background-color: rgba(177, 222, 210, 0.6);
      }
    }
  }
  &__descriptions {
    @include flex-h(space-around, flex-start);
    @include padding-v(135px);
    @include breakpoint(xs) {
      @include padding-v(30px);
      @include flex-v(center, center);
    }
    @include breakpoint(s) {
      @include padding-v(70px);
    }
    &-item {
      @include flex-v(stretch, center);
      max-width: 450px;
      flex: 1;
      @include ie_or_edge() {
        width: 450px;
        flex: inherit;
      }
      background-color: white;
      border-radius: 15px;
      padding: 35px;
      position: relative;
      align-self: stretch;
      @include margin-h(12px);
      @include breakpoint(xs) {
        margin: 18px 10%;
        width: 80%;
        max-width: inherit;
      }
      @include breakpoint(s) {
        max-width: 300px;
      }
      &-image {
        position: absolute;
        top: -75px;
        @include size(150px);
        @include ie_or_edge() {
          position: relative;
          top: -100px;
          margin-bottom: -100px;
        }
        @include breakpoint(xs) {
          @include size(40px);
          top: -20px;
          @include ie_or_edge() {
            top: -50px;
            margin-bottom: -50px;
          }
        }
        @include breakpoint(s) {
          @include size(60px);
          top: -30px;
          @include ie_or_edge() {
            top: -60px;
            margin-bottom: -60px;
          }
        }
      }
      &-headline {
        font-family: $font_nettoBold;
        @include text(40px, 48px, 0.4px);
        color: #231f20;
        margin: 75px 0;
        @include breakpoint(xs) {
          @include text(14px, 18px, 0.14px);
          margin: 10px 0 10px;
        }
        @include breakpoint(s) {
          @include text(22px, 48px, 0.16px);
          margin: 0 0 20px;
        }
      }
      &-text {
        font-family: $font_nettoRegular;
        @include text(30px, 36px, 0.3px);
        color: #231f20;
        max-width: 100%;
        @include breakpoint(xs) {
          @include text(12px, 18px, 0.12px);
        }
        @include breakpoint(s) {
          @include text(16px, 24px, 0.16px);
        }
      }
    }
  }
}
</style>
